import CreditCardImg from './img-credit-card.svg'
import ECheckImg from './img-online-payment.svg'
import ACHImg from './img-ach.svg'

const Images = {
  CreditCard: CreditCardImg,
  ECheck: ECheckImg,
  ACH: ACHImg,
}

export default Images
